  <template>
  <van-row justify="center" class="page-wrapper">
    <van-col
      span="24"
      class="place-content-center round-shadow-btn flex-display-fix"
    >
      <div>
        <div v-if="paymentHistory.length">
          <info-message
            v-for="message in paymentHistory"
            :key="message.id"
            class="history-item"
          >
            <van-row>
              <h5 class="energy-title apply-loader">
                {{ $t("paymentHistorySearch.energyTitle") }}
              </h5>
              <!--              <p class="payment-type">-->
              <!--                {{ message.pay }}-->
              <!--              </p>-->
              <!--              <van-col span="12" class="payment-history-left apply-loader">-->
              <!--                {{ $t("paymentHistorySearch.period") }}-->
              <!--              </van-col>-->
              <!--              <van-col span="12" class="payment-history-right apply-loader">-->
              <!--                {{ message.period }}-->
              <!--              </van-col>-->

              <van-col span="12" class="payment-history-left apply-loader">
                {{ $t("paymentHistorySearch.date") }}
              </van-col>
              <van-col span="12" class="payment-history-right apply-loader">
                {{ message.updated_at.split("T")[0] }}
              </van-col>
              <van-col span="12" class="payment-history-left apply-loader">
                {{ $t("paymentHistorySearch.sum") }}
              </van-col>
              <van-col span="12" class="payment-history-right apply-loader">
                {{ message.amount + " грн" }}
              </van-col>
            </van-row>
          </info-message>
        </div>
        <div v-else class="place-content-center">
          <info-message>
            {{ $t("global.noData") }}
          </info-message>
        </div>
      </div>
    </van-col>
  </van-row>
</template>
<script>
import InfoMessage from "@/components/content/InfoMessage";
export default {
  name: "PaymentHistorySearchResults",
  components: { InfoMessage },
  // data() {
  //   return {
  //     paymentHistory: [],
  //   };
  // },
  computed: {
    paymentHistory() {
      const payments =
        this.$store.state.PaymentHistory.paymentHistoryEasyPay.data || [];

      return [...payments].sort((a, b) => {
        const dateA = new Date(a.updated_at || a.created_at || 0).getTime();
        const dateB = new Date(b.updated_at || b.created_at || 0).getTime();

        if (dateA !== dateB) {
          return dateB - dateA;
        }

        return Number(b.id || 0) - Number(a.id || 0);
      });
    },
  },
  created() {
    this.getPaymentHistory();
    // console.log("PaymentHistorySearchResults: ", JSON.stringify(this.$route.params))
  },
  destroyed() {
    this.$store.commit("PaymentHistory/CLEAR_PAYMENT_HISTORY_EASY_PAY");
  },
  methods: {
    async getPaymentHistory() {
      let ls;
      ls = this.$route.params.account;
       await this.$store.dispatch(
        "PaymentHistory/getPaymentHistoryFromEasyPayDb",
        ls
      );
      // console.log("PaymentHistorySearchResults: ", JSON.stringify(res));
      // if (res.success) {
      //   this.paymentHistory = res.data;
      // }


    },
  },
};
</script>
<style scoped>
.payment-type {
  font-size: 12px;
  margin: 5px 5px 0;
}
.energy-title {
  color: #2e73b4;
  font-size: 18px;
  margin: 5px 5px 0;
}
.payment-history-left,
.payment-history-right {
  margin-top: 5px;
  font-size: 14px;
  margin-bottom: 10px;
  color: #0b0b0b;
}
.payment-history-right {
  text-align: right;
  padding-right: 15px;
}
.payment-history-left {
  text-align: left;
  padding-left: 15px;
}
</style>
